import "./assets/fonts/fontello/css/animation.css";
import "./assets/fonts/fontello/css/fontello.css";

import { StarRating } from "./star-rating";

export default StarRating;
